import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsBillingAddressFieldset } from './cms-billing-address-fieldset.interface';
import { CmsPaperlessPreferenceFieldset } from './cms-paperless-preference-fieldset.interface';

export interface CmsCardForm {
  accountNameField: FormField;
  addressFieldset: FormFieldset;
  billingAddressFieldset: CmsBillingAddressFieldset;
  cardNumberField: FormField;
  cvvField: FormField;
  expiryDateField: FormField;
  monthlyRenewalField: FormField;
  paperlessPreferenceFieldset: CmsPaperlessPreferenceFieldset;
}
